import React from 'react';
import Tooltip from '../../../../components/Tooltip';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  publicJobTitle: {
    id: 'account.super-matches.list.header.public-job-title',
    defaultMessage: 'Public job title',
  },
  jobProfile: {
    id: 'account.super-matches.list.header.job-profile',
    defaultMessage: 'Job Profile',
  },
  jobProfileMatch: {
    id: 'account.super-matches.list.header.job-profile-match',
    defaultMessage: 'Job Profile',
  },
  qAndRMatch: {
    id: 'account.super-matches.list.header.q-and-r-match',
    defaultMessage: 'Q&R match',
  },
  superMatch: {
    id: 'account.super-matches.list.header.super-match',
    defaultMessage: 'SuperMatch',
  },
  contactSuccessRateTooltip: {
    id: 'account.super-matches.list.contact-success-rate.tooltip',
    defaultMessage: 'Contact Success Rate',
  },
  contactSuccessRate: {
    id: 'account.super-matches.list.contact-success-rate',
    defaultMessage:
      "This is a new feature — the candidate's Contact Success Rate will increase as they respond to more contact requests.",
  },
  actions: {
    id: 'attrs.actions',
    defaultMessage: 'Actions',
  },
});

const SuperMatchesListHeader = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="font-weight-600 flex-space-between margin-bottom-1">
      <div>{formatMessage(messages.publicJobTitle)}</div>
      <div>{formatMessage(messages.jobProfile)}</div>
      <div>{formatMessage(messages.jobProfileMatch)}</div>
      <div>{formatMessage(messages.qAndRMatch)}</div>
      <div>{formatMessage(messages.superMatch)}</div>
      <Tooltip text={formatMessage(messages.contactSuccessRate)}>
        <div>{formatMessage(messages.contactSuccessRateTooltip)}</div>
      </Tooltip>
      <div>{formatMessage(messages.actions)}</div>
      <div>Report</div>
    </div>
  );
};

export default SuperMatchesListHeader;
